import { combineReducers } from 'redux';
import game from './game';
import app from './app';

const countUpApp = combineReducers({
  game,
  app,
});

export default countUpApp;
